import { api } from "#app/http/api";
import { ApiError, extractDomainError } from "#shared/infra/apiError";
import { NestingRunView } from "shared";

export type RunOptimizationNestingParams = {
  optimizationId: string;
  cutWidth?: number;
  skeletonWidth?: number;
  newScrapMaterialBillingRate?: number;
};

export const runOptimizationNesting = async ({
  optimizationId,
  ...body
}: RunOptimizationNestingParams): Promise<NestingRunView> => {
  const response = await api.nesting.runOptimizationNesting.mutation({
    params: { id: optimizationId },
    body,
  });

  if (response.status === 201) {
    return response.body;
  }

  const domainError = extractDomainError(response.body);
  if (domainError) {
    throw domainError;
  }

  throw new ApiError("Failed to run optimization nesting", response.status, response.body);
};
